import React from "react";

const Bonus = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M18.667 13.03c.947-1.309 2.144-2.123 3.186-2.123.327 0 .627.073.893.226 1.294.754 1.307 2.994.027 5.207l-.098.155 1.381.839H34V4.467A2.47 2.47 0 0 0 31.533 2H18.667v11.03ZM11.94 17.334l1.388-.842c-.03-.05-.064-.094-.095-.145-1.28-2.227-1.266-4.467.02-5.214.267-.153.567-.226.894-.226 1.044 0 2.244.817 3.187 2.132V2H4.467A2.47 2.47 0 0 0 2 4.467v12.867h9.94ZM17.334 19.305l-3.894 4.242a.682.682 0 0 1-.774.154.667.667 0 0 1-.38-.694c.014-.093.02-.22.02-.38 0-.533-.1-1.353-.546-1.86-.447-.507-1.207-.647-2.26-.44a.66.66 0 0 1-.747-.413c-.12-.3 0-.64.273-.814l.715-.433H2v12.867A2.47 2.47 0 0 0 4.467 34h12.867V19.305ZM26.252 18.667l.648.393c.24.1.407.34.407.614 0 .366-.314.66-.667.666-.047 0-.093 0-.14-.013-1.06-.207-1.814-.067-2.26.44-.694.793-.527 2.227-.527 2.24a.668.668 0 0 1-.38.694.684.684 0 0 1-.773-.154l-3.893-4.24v14.694h12.866A2.47 2.47 0 0 0 34 31.534V18.667h-7.748Z"
              fill={fill}
        />
    </svg>
);

export default Bonus;